import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import CommonGrid from "../CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";
// import { fetchLoanAging } from "../../store/reducers/dashboardSlice/api";
import {
  gridColumns_LoanAgeing,
  loanAgingHeader,
} from "../../Utils/TableColumnDefs";
import { reduceSum } from "../../Utils";
import { useAbortController } from "../../hooks/useAbortController";
import { loadingTypes } from "../../Utils/constant";
import { fetchBorrowerLoanAging } from "../../store/reducers/dashboardSlice/api";
import useBorrowerDashboardTwo from "../../pages/Borrowers/BorrowerDashboardTwo/apis/useBorrowerDashboardTwo";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChartBorrower = () => {
  const [show, setShow] = useState(false);
  const loanAgingData = useSelector(
    (state) => state.dashboard.borrowerLoanAgingData.data
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerLoanAgingData.status
  );
  const { activeAccountList } = useBorrowerDashboardTwo();
  const { signal } = useAbortController();
  const dispatch = useDispatch();

  const valuesToPopulate = loanAgingData?.resp;

  const requestedData = {
    borrowerRecID: activeAccountList?.map((el) => el.value).join(" "),
  };

  useEffect(() => {
    if (status === loadingTypes.idle && activeAccountList?.length) {
      dispatch(
        fetchBorrowerLoanAging({
          requestedData,
          signal,
        })
      );
    }
  }, [status, dispatch, activeAccountList]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const LabelsData = valuesToPopulate?.map((data) => data.categoryName);
  const chartValues = valuesToPopulate?.map((data) => data.count);

  const totalValue = reduceSum(valuesToPopulate?.map((data) => data.count));
  const data = {
    labels: LabelsData,
    datasets: [
      {
        data: chartValues,
        backgroundColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
          "rgba(255, 99, 13, 1)",
          "rgba(54, 162, 23, 1)",
          "rgba(255, 206, 8, 1)",
          "rgba(75, 192, 19, 1)",
          "rgba(153, 102, 25, 1)",
          "rgba(255, 159, 6, 1)",
        ],
        borderWidth: 0,
        cutout: "65%",
        // radius: "80%",
        hoverOffset: 5,
      },
    ],
  };
  const textCenter = {
    id: "textCenter",
    beforeDatasetDraw: function (chart, a, b) {
      var width = chart.width,
        height = chart.height - 12,
        ctx = chart.ctx;

      ctx.restore();
      var fontSize = (height / 114).toFixed(2);
      ctx.font = fontSize - 1 + "rem sans-serif";
      ctx.textBaseline = "middle";

      var text = "Total",
        textX = Math.round((width - ctx.measureText(text).width) / 2) - 55,
        textY = height / 2;

      var text2 = totalValue,
        textX2 = Math.round((width - ctx.measureText(text2).width) / 2) - 55,
        textY2 = height / 2;

      ctx.fillText(text, textX, textY);
      ctx.fillText(text2, textX2, textY2 + 30);
      ctx.save();
    },
  };
  return (
    <>
      <div className="col-lg-12">
        <div
          className="bg-white w-100 d-flex flex-column justify-content-center align-items-center mt-3"
          style={{ height: "96%", position: "relative" }}
        >
          <ChartDetailsModal
            handleClose={handleClose}
            loanAgingTable={valuesToPopulate}
            show={show}
            Chart={
              <div className="col-sm-12 bg-white d-flex flex-column justify-content-center align-items-center">
                <h5>Loan Aging</h5>
                <div className="chart-container">
                  <Doughnut
                    options={options}
                    data={data}
                    plugins={[textCenter]}
                    key={totalValue}
                  />
                </div>
              </div>
            }
          />

          <div className="chart-container loanAgingChart" onClick={handleShow}>
            {status === "fulfilled" ? (
              totalValue < 1 ? (
                <p>NO DATA AVAILABLE</p>
              ) : totalValue === undefined ? (
                <SpinnerBlock height={"10vh"} />
              ) : (
                <Doughnut
                  options={options}
                  data={data}
                  plugins={[textCenter]}
                  key={totalValue}
                />
              )
            ) : activeAccountList.length === 0 ? (
              <p>No active loans</p>
            ) : status === "loading" || status === "idle" ? (
              <SpinnerBlock height={"10vh"} />
            ) : (
              "Failed"
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DoughnutChartBorrower;
const options = {
  // responsive: true,

  plugins: {
    legend: {
      position: "right",
      labels: {
        usePointStyle: true,
        padding: 12,
        font: {
          size: 11,
        },
      },
    },
    title: {
      display: false,
    },
  },
};

export const ChartDetailsModal = ({
  handleClose,
  loanAgingTable,
  show,
  Chart,
}) => {
  return (
    <div className="">
      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        dialogClassName="mw-100 p-5"
      >
        <Modal.Header closeButton>
          <Modal.Title>Chart Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5">
          {Chart}
          {loanAgingTable && (
            <CommonGrid
              gridColumns={loanAgingHeader}
              columnData={loanAgingTable}
              viewAllModal={false}
              tHeight={"65vh"}
              tableTotal={["amount"]}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* {summary.principalBalance} */}
          {/* {summary.principalBalance} */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};
